import React from 'react'
import { useLoader } from './useLoader'
import { appointmentsService } from '../services/AppointmentsService'
import { store } from '../store'

export const useAppointmentLoader = (id?: string, businessId?: string) => {
  const [loading, load] = useLoader(async () => {
    if (!id || !businessId) return
    await appointmentsService.loadAppointment({ id, businessId })
  })
  const loadRef = React.useRef(load)
  React.useEffect(() => {
    loadRef.current = load
  }, [load])
  React.useEffect(() => {
    if (!id || !businessId) return
    loadRef.current()
  }, [id, businessId])

  const appointment = store.appointments.appointment
  return {
    appointment,
    loading,
    reload: () => loadRef.current()
  }
}
